import type { ButtonProps} from '@uikit';
import { Button, Spinner } from '@uikit';

import type { CanClaimOfferEntry } from '@shared/api/types/hotOffers';

export interface HotOfferClaimButtonProps extends ButtonProps<'button'> {
  isLoading: boolean;
  isCanClaimOfferLoading: boolean;
  canClaimOffer?: CanClaimOfferEntry;
  pausedText: string | null;
}

export default function HotOfferClaimButton({
  isLoading,
  isCanClaimOfferLoading,
  canClaimOffer,
  pausedText,
  disabledVisually,
  ...props
}: HotOfferClaimButtonProps) {
  const isClaimed = canClaimOffer?.attributes?.claimed;

  const isPaused = !!pausedText;

  const isDisabledButton = disabledVisually || isCanClaimOfferLoading || isLoading || isPaused;

  return (
    <Button
      {...(canClaimOffer?.attributes.claimUrl
        ? {
            as: 'a',
            href: canClaimOffer?.attributes.claimUrl,
            target: '_blank',
            rel: 'noreferrer',
          }
        : {})}
      size="lg"
      variant="secondary"
      className="flex-grow font-semibold h-[50px]"
      disabled={isDisabledButton}
      {...props}
    >
      {isClaimed && 'Offer Claimed'}

      {!isClaimed && !isPaused && (isLoading ? <Spinner size="md" color="light" /> : 'Claim Offer')}

      {!isClaimed && isPaused && pausedText}
    </Button>
  );
}
